module.exports = {
      id: "icon-benifits-delete-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "images/js_src_vue/page_eagle_landing/sprite.b4f41d19.svg#icon-benifits-delete-usage",
      toString: function () {
        return this.url;
      }
    }